import { Grid, makeStyles, InputAdornment } from '@material-ui/core';
import MROTextField from 'components/form_components/TextField';
import React, { useContext, useEffect, useState } from 'react'
import CommonDialog from 'views/Operations/Base/Inprogress/CommonDialog';
import LockIcon from "assets/icons/Lock.svg";
import UnlockIcon from "assets/icons/Unlock.svg";
import InfoDetails from 'views/Operations/Base/Inprogress/InfoDetails';
import DateField from 'views/Accounts/Workshop/Maintenance/ManageInvoice/DateField';
import { format24HrDateOnly, getOrganisationId } from 'lib/utils/common_utils';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { ToastMessageContext } from 'lib/contexts/message_context';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    modal: {
        "& .MuiDialog-paperWidthMd": {
            maxWidth: "400px",
            padding: '15px'
        },
    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    },

}))

export default function Receipt(props) {
    const classes = useStyles()
    const { handleClose, currentSelection, id, setCoreValues, tab } = props
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)
    const [isUnlock, setIsUnlock] = useState(false)
    const [lockValue, setLockValue] = useState("")
    const [unlockValue, setUnlockValue] = useState("")
    const [lateDays, setLateDays] = useState("")
    const [lateFees, setLateFees] = useState("")
    const message = useContext(ToastMessageContext)

    const generalDetails = [
        { label: 'Due Date', value: currentSelection?.due ? format24HrDateOnly(currentSelection?.due) : "-" },
        { label: 'Day Fee', value: currentSelection?.day_fee ?? "-" },
    ]


    const handleLateFees = (date) => {
        if (date !== "Invalid date") {
            let date_format = "DD/MM/YYYY"
            let format_dueData = moment(currentSelection?.due, "DD-MM-YYYY HH:mm").format(date_format)
            const dueDay = moment(format_dueData, date_format)
            const received = moment(date, date_format)
            const diffInDays = received.diff(dueDay, 'days');
            setLateDays(diffInDays < 0 ? 0 : diffInDays)
            let late_fee = parseFloat(currentSelection?.day_fee ?? 1) * (diffInDays < 0 ? 0 : diffInDays)
            setLockValue(late_fee)
            if (tab === "commercial") { setCoreValues((ps) => ({ ...ps, lateFees: late_fee })) }
        }
    }

    const handleSubmitReceipt = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        let valid = true;
        let error = {};


        for (let pair of formData.entries()) {
            const value = pair[1];
            const key = pair[0];

            if (!value) {
                error[key] = true;
                valid = false;
            }
        }

        if (!valid) {
            setErrors(error);
            return;
        }
        setLoading(true)

        formData.append("organisation_id", getOrganisationId())
        formData.append("id", id)


        const serviceMethod = PartSalesServices.updateCoreReceipt


        const successMessage = "Receipt updated successfully!";

        try {
            const res = await serviceMethod(formData);
            message.showToastMessage({
                message: successMessage,
                variant: "success",
            });
            handleClose();
        } catch (res) {
            handleClose();
            message.showToastMessage({
                message: res?.error || "Something went wrong. Try again!",
                variant: "error",
            });
        } finally {
            setLoading(false);
        }



    }

    useEffect(() => {
        if (currentSelection !== undefined) {
            setLateDays(currentSelection?.late_day)
            // if (currentSelection?.received !== null) {
            //     let formated_date = moment(currentSelection?.received, "DD-MM-YYYY HH:mm").format("DD/MM/YYYY")
            //     handleLateFees(formated_date)
            // }
            setLockValue(currentSelection?.late_fee)
        }
    }, [currentSelection])

    return (
        <CommonDialog
            title="Item Receipt"
            onClose={handleClose}
            onSubmit={handleSubmitReceipt}
            loading={loading}
            submitLabel="Complete"
            edit={true}

            classes={classes.modal}
        >

            <InfoDetails generalDetails={generalDetails} md={12} />

            <Grid item xs={12}>


            </Grid>

            <Grid className={classes.purchaseGrid} item xs={12}>
                <DateField
                    required
                    name="received"
                    label={"Received Date *"}
                    InputLabelProps={{ shrink: true }}
                    error={errors.received}
                    helperText={errors.received ? "*please enter a Received date" : null}
                    onChange={(e) => {
                        setErrors({ ...errors, received: false });
                        handleLateFees(e)
                    }}
                    placeholder={"DD/MM/YYYY"}
                    defaultValue={currentSelection?.received ?? ""}
                    type={"core"}

                />
            </Grid>

            <Grid item xs={12}>
                <MROTextField
                    name={"late_days"}
                    label={"Late Days *"}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                        className: classes.disableField, // disable pointer in input field only
                    }}
                    defaultValue={currentSelection?.late_day ?? ""}
                    value={lateDays}
                    error={errors.late_days}
                    helperText={errors.late_days ? "*please enter Late Days" : null}
                    onChange={(e) => { setErrors({ ...errors, late_days: false }); }}

                />


            </Grid>

            <Grid xs={12}>

                <MROTextField
                    name={"late_fee"}
                    label={"Late Fee *"}
                    placeholder={"Late Fee "}
                    defaultValue={currentSelection?.late_fee ?? ""}
                    inputProps={{
                        maxLength: 30,
                        readOnly: !isUnlock, // prevent editing if locked
                        className: !isUnlock ? classes.disableField : '', // disable pointer in input field only
                    }}
                    InputLabelProps={{ shrink: true }}
                    error={errors.late_fee}
                    className={!isUnlock && classes.disableField}
                    value={!isUnlock ? lockValue : unlockValue}
                    onChange={(e) => {

                        if (isUnlock) {
                            let val = e.target.value;
                            if (isNaN(val)) {
                                val = val.replace(/[^0-9\.]/g, "");
                                if (val.split(".").length > 2)
                                    val = val.replace(/\.+$/, "");
                            }
                            // handleUnlockMarkup(val)
                            setUnlockValue(val)
                            setErrors((prevState) => ({
                                ...prevState,
                                late_fee: false,
                            }))
                            if (tab === "commercial") { setCoreValues((ps) => ({ ...ps, lateFees: val })) }
                        }
                    }}
                    InputProps={{


                        endAdornment: (<>
                            <InputAdornment position="start" style={{ cursor: 'pointer', paddingRight: "10px" }}>


                                {isUnlock ? <img src={UnlockIcon} height={"20px"} style={{ cursor: 'pointer', pointerEvents: !isUnlock && "" }} onClick={() => {
                                    setIsUnlock(false)


                                }} /> : <img src={LockIcon} style={{ cursor: 'pointer' }} height={"20px"} onClick={() => {
                                    setIsUnlock(true)

                                }} />}
                            </InputAdornment>

                        </>),
                        style: {
                            pointerEvents: 'auto', // makes adornment clickable even if input is disabled
                        },
                    }}
                ></MROTextField>

            </Grid>






        </CommonDialog>
    )
}
